var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArFunctionSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "16,13.8818359 11.4472656,11.6054688 10.5527344,13.3945312 15,15.6181641 15,20 17,20 17,15.6181641  21.4472656,13.3945312 20.5527344,11.6054688  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6582031,1.5527344l-4.1054688,2.0527344l0.8945312,1.7890625L15,3.6177368V8h2V3.6181641l3.5527344,1.7763672 l0.8945312-1.7890625l-4.1064453-2.0527344C16.5009766,1.1328125,15.4980469,1.1328125,14.6582031,1.5527344z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,28.3822632V24h-2v4.3818359l-3.5527344-1.7763672l-0.8945312,1.7890625l4.1064453,2.0527344 C15.0791016,30.6572266,15.5390625,30.7617188,16,30.7617188s0.921875-0.1044922,1.3417969-0.3144531l4.1054688-2.0527344 l-0.8945312-1.7890625L17,28.3822632z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5527344,20.1054688L4,21.8818359V18H2v4.8818359c0,0.7636719,0.4238281,1.4492188,1.1054688,1.7890625 l4.4472656,2.2236328l0.8945312-1.7890625L5.2363281,23.5l3.2109375-1.6054688L7.5527344,20.1054688z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5527344,5.1054688L3.1064453,7.3291016C2.4238281,7.6689453,2,8.3544922,2,9.1181641V14h2v-3.8818359 l3.5527344,1.7763672l0.8945312-1.7890625L5.2363281,8.5l3.2109375-1.6054688L7.5527344,5.1054688z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8945312,7.3291016l-4.4472656-2.2236328l-0.8945312,1.7890625L26.7636719,8.5l-3.2109375,1.6054688 l0.8945312,1.7890625L28,10.1181641V14h2V9.1181641C30,8.3544922,29.5761719,7.6689453,28.8945312,7.3291016z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,21.8818359l-3.5527344-1.7763672l-0.8945312,1.7890625L26.7636719,23.5l-3.2109375,1.6054688l0.8945312,1.7890625 l4.4462891-2.2236328C29.5761719,24.3310547,30,23.6455078,30,22.8818359V18h-2V21.8818359z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArFunctionSmall);
export default __webpack_public_path__ + "static/media/ar-function--small.1d541395103df260eaa99fcef95aa9ea.svg";
export { ForwardRef as ReactComponent };